const store = {
  isDesktop: window.innerWidth >= 768 // 初期値はブレイクポイントかどうかで決定
};

function updateIsDesktop() {
  store.isDesktop = window.innerWidth >= 768;
}

window.addEventListener('resize', updateIsDesktop);

window.alpine = {
  store,
  updateIsDesktop
};